import { render, staticRenderFns } from "./orderStatusList.vue?vue&type=template&id=495a67f8&scoped=true"
import script from "./orderStatusList.vue?vue&type=script&lang=js"
export * from "./orderStatusList.vue?vue&type=script&lang=js"
import style0 from "./orderStatusList.vue?vue&type=style&index=0&id=495a67f8&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495a67f8",
  null
  
)

export default component.exports